import React from 'react';

const LoadingModal = ({ onClose, title }) => {
  return (
    <div className="page-modal">
        <div className="modal">
            <div className="modal-content">
                <h1>{title}</h1>
                <div className="loading-spinner"/>
                
                <div className="modal-buttons">
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    </div>
  );
};

export default LoadingModal;
